import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=124e7a3c&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
import style0 from "./Add.vue?vue&type=style&index=0&id=124e7a3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e7a3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124e7a3c')) {
      api.createRecord('124e7a3c', component.options)
    } else {
      api.reload('124e7a3c', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=124e7a3c&scoped=true", function () {
      api.rerender('124e7a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/customerPointsManagement/dialogs/Add.vue"
export default component.exports